import { useFavorites } from '@/hooks/useFavorites';

interface FavoriteButtonProps {
  id: string;
  variant?: 'floating' | 'solid';
  className?: string;
}

export default function FavoriteButton({
  id,
  variant = 'floating',
  className = '',
}: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(id);

  const base =
    'inline-flex items-center justify-center transition-colors cursor-pointer whitespace-nowrap';
  const styles =
    variant === 'floating'
      ? `h-9 w-9 rounded-full backdrop-blur ${
          active
            ? 'bg-accent-500 text-background-50'
            : 'bg-foreground-950/35 text-background-50 hover:bg-accent-500'
        }`
      : `h-10 gap-2 rounded-md px-4 text-sm font-medium border ${
          active
            ? 'border-accent-500 bg-accent-500 text-background-50 hover:bg-accent-600'
            : 'border-background-300 bg-background-50 text-foreground-700 hover:border-accent-400 hover:text-accent-600'
        }`;

  return (
    <button
      type="button"
      aria-label={active ? '取消收藏' : '加入收藏'}
      aria-pressed={active}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleFavorite(id);
      }}
      className={`${base} ${styles} ${className}`}
    >
      <i className={active ? 'ri-bookmark-fill' : 'ri-bookmark-line'}></i>
      {variant === 'solid' && <span>{active ? '已收藏' : '收藏'}</span>}
    </button>
  );
}